export class Repository {
  
}